import React, { useState } from 'react'
import gql from 'graphql-tag'
import { get } from 'ts-object-path'
import { useQuery } from '@apollo/react-hooks'
import {
  PartnerByIdAllClients,
  PartnerByIdAllClientsVariables
} from '../../_generated/PartnerByIdAllClients'

export const QUERY = gql`
query PartnerByIdAllClients($id: ID!, $offset: Int!, $limit: Int!){
  clients {
    allInStructureUnderPartnerId(id: $id, pagination: {offset: $offset, limit: $limit}) {
      id
      name
      email
      aggregated {
        balance
        equity
        deposited
        withdrawn
        fees
        currency
        profit
      }
    }
  }
}`

export type Q = PartnerByIdAllClients
export type V = PartnerByIdAllClientsVariables
export type R = Q['clients']['allInStructureUnderPartnerId']

export const parseData = (data: Q): R => {
  return get(data, p => p.clients.allInStructureUnderPartnerId)
}

export const parseMoreData = (prevResult: Q, fetchMoreResult: Q): Q => {
  if (!fetchMoreResult) return prevResult
  const clients = [...parseData(prevResult), ...parseData(fetchMoreResult)]
  const r: Q = JSON.parse(JSON.stringify(prevResult))
  r.clients.allInStructureUnderPartnerId = clients
  return r
}

type T = {
  partnerId: string
  limit: number
  offset: number
}

export function Use<T>({ partnerId: id, limit, offset = 0 }) {
  const [loadingMore, setLoadingMore] = useState(false)
  const query = useQuery<Q, V>(
    QUERY,
    {
      variables: {
        id,
        limit,
        offset,
      }
    }
  )

  const { loading, error, data, fetchMore } = query
  const parsecData = parseData(data)

  type TM = {
    limit: number
  }

  const more = ({limit = 4}) => {
    setLoadingMore(true)
    
    fetchMore({
      variables: {
        offset: parsecData.length,
        limit
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        setLoadingMore(false)
        return parseMoreData(prev, fetchMoreResult)
      }
    })

    return () =>{}
}

  return { loading, error, data: parsecData, fetchMore, parseMoreData, more, loadingMore }
}
